import { v4 } from "uuid";
import { getDictByCode } from "./api"

//对象转为query传参
export const toQuery = (obj: any) =>
  Object.entries(obj)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

//生成随机id
export const createId = () => {
  const newUuid = v4();
  return newUuid.replace(/[-]/g, "");
};
// 视频类型
export const videoType = ['avi', 'mov', 'mp4'];

//兼容安卓g跟ios的tabbar
export const setDomCss = (el: any, cssname: any, val: any, type: any) => {
  const u = navigator.userAgent;
  if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    if (type === "ios") {
      el.style[cssname] = val;
    }
  } else {
    if (type === "ard") {
      el.style[cssname] = val;
    }
  }
};

export const getUrlParams = function (url: string, key: string) {
  // 通过 ? 分割获取后面的参数字符串
  const urlStr = url.split("?")[1];
  if(!urlStr) return
  // 创建空对象存储参数
  const obj = {};
  // 再通过 & 将每一个参数单独分割出来
  const paramsArr = urlStr.split("&");
  for (let i = 0, len = paramsArr.length; i < len; i++) {
    // 再通过 = 将每一个参数分割为 key:value 的形式
    const arr = paramsArr[i].split("=");
    obj[arr[0]] = arr[1];
  }
  return obj[key];
};

//获取数据字典数据  isTransform:格式是否需要转换
export const getDictionaryData = (code: string, isTransform: boolean) => {
  return new Promise((resolve, reject) => {
    getDictByCode(code).then((res: any) => {
      if (res?.code == "00000") {
        resolve(
          isTransform
            ? res?.data[0]?.values.map((item: any) =>({ text: item.name, value: item.code}))
            : res?.data[0]?.values
        );
      } else {
        reject(res?.msg);
      }
    }).catch((err) => {});
  });
};

/**
 * 防抖 常用场景：搜索栏输入
 * @param {要嵌套的函数} func
 * @param {防连续点击时间} wait
 * @returns
 */
export const deBounce = (func: any, wait: number = 1000) => {
  let timeOut: any = null;
  return (...args: any) => {
    const context = this;
    clearTimeout(timeOut); // 一定要清除定时器
    timeOut = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};

/**
 * 节流 常用场景：防止连续点击
 * @param {要嵌套的函数} func
 * @param {防连续点击时间} wait
 * @returns
 */
export const throttle = (func: any, wait: number = 1000) => {
  let timeout: any = null;
  return (...args: any) => {
    if (!timeout) {
      func.apply(this, args);
      timeout = setTimeout(() => {
        timeout = null; // 一定要清除定时器
      }, wait);
    }
  };
};

/**
 * 
 * @param imgPath 
 * @returns 
 */
export const require = (imgPath) => {
  try {
    const handlePath = imgPath.replace('@', '..')
    return new URL(handlePath, import.meta.url).href
  } catch (error) {
    console.warn(error)
  }
}